import { EditorContent, EditorContentProps } from '@tiptap/react';

import { Box, chakra, forwardRef, StyleProps } from '@bonusly/design-system';

const StyledEditorContent = chakra(EditorContent);

interface StyledEditorProps extends Omit<EditorContentProps, 'color' | 'height' | 'width' | 'as'>, StyleProps {}

export const StyledEditor = forwardRef<StyledEditorProps, 'div'>(({ editor, ...rest }, ref) => {
	return (
		<Box
			sx={{
				a: {
					color: 'blue.500',
					textDecoration: 'underline',
				},
				blockquote: {
					borderLeftWidth: 4,
					borderLeftColor: 'gray.200',
					marginLeft: 0,
					paddingLeft: 4,
				},
				pre: {
					bg: 'grayAlpha.100',
					fontSize: 'sm',
					p: 2,
				},
				h1: {
					fontSize: '2xl',
					fontWeight: 'semibold',
				},
				h2: {
					fontSize: 'xl',
					fontWeight: 'semibold',
				},
				h3: {
					fontSize: 'lg',
					fontWeight: 'semibold',
				},
				ul: {
					pl: 8,
				},
				ol: {
					pl: 8,
				},
				'.tiptap': {
					...rest,
				},
				'.tiptap p.is-editor-empty:first-of-type::before': {
					color: 'gray.400',
					content: 'attr(data-placeholder)',
					float: 'left',
					height: 0,
					pointerEvents: 'none',
				},
			}}
		>
			<StyledEditorContent editor={editor} ref={ref} />
		</Box>
	);
});
